import type { Messages } from "../types";

export const am = {
  "common": {
    "brand": "UN8",
    "brandTag": "Exclusive Christian dating",
    "continue": "Continue",
    "leave": "Leave",
    "leaveForNow": "Leave for now",
    "yes": "Yes",
    "no": "No",
    "goBack": "Go back",
    "saving": "Saving…",
    "submitting": "Submitting…",
    "pleaseWait": "Please wait…",
    "ellipsis": "…",
    "male": "Male",
    "female": "Female",
    "phases": {
      "gate": "Gate",
      "verify": "Verify",
      "setup": "Setup",
      "profile": "Profile"
    },
    "storageQuota": "This phone is out of space for saved answers. Free some storage, then try again.",
    "storageDisabled": "This browser will not save your answers. Turn off private mode, or allow site data, then reload.",
    "charMeta": "{len}/{min} min · {current}/{max}",
    "charMetaMin": "min {min} characters"
  },
  "welcome": {
    "promise": "Our goal is that you delete this app as quickly as possible.",
    "sub": "UN8 helps serious Christian singles find a life partner — then leave. Verified. Values-first. No endless swiping.",
    "signedInAs": "Signed in as {email}",
    "liveServer": " · live server",
    "deviceOnly": " · this device only",
    "migrateOffer": "This device still has a local profile. Upload it to the shared server so other phones can see you after moderation? Nothing is uploaded until you choose.",
    "uploadLocalProfile": "Upload my local profile",
    "keepOnDevice": "Keep it on this device only",
    "migrateNeedGender": "Choose Male or Female in your profile first.",
    "migrateDone": "Profile text uploaded. Re-upload ID, video, and photos so moderation can review them.",
    "deleteConfirm": "Permanently delete your account, all messages, and all media (including ID and video) from the server?",
    "accountDeleted": "Account deleted.",
    "begin": "Begin",
    "continueOnboarding": "Continue onboarding",
    "logIn": "Log in",
    "logOut": "Log out",
    "reviewConsole": "Review console",
    "matching": "Matching",
    "deleteMyAccount": "Delete my account"
  },
  "faith": {
    "eyebrow": "Faith gate",
    "title": "Christians only",
    "text": "UN8 is a community of followers of Jesus Christ, for members seeking a marriage-minded partner who shares that faith. This gate cannot be skipped.",
    "yesTitle": "I am a Christian",
    "yesBody": "I follow Jesus Christ and seek a marriage-minded partner who shares this faith.",
    "noTitle": "I am not a Christian",
    "noBody": "UN8 is not the right place for me — and that is okay.",
    "respectTitle": "With respect",
    "respectBody": "UN8 is built for one community, and we would rather be honest than waste your time. Use Leave below, or Back, if this is not your home.",
    "sharedTitle": "Shared foundation",
    "sharedBody": "Faith is not a label here. It is the ground on which you meet.",
    "hintNotChristian": "UN8 is for followers of Jesus Christ. Tap Leave below, or choose the Christian option if that is you.",
    "hintUnset": "Tap “I am a Christian” to continue, or Leave / Back if this is not your home."
  },
  "rules": {
    "eyebrow": "Community covenant",
    "title": "How we treat each other",
    "text": "Affirm every rule. All three are required. Violations lead to permanent removal. Fake profiles are banned forever.",
    "agreeContinue": "I agree — continue",
    "respectful": {
      "title": "Be respectful",
      "description": "Speak and act with dignity. Every person here is made in God’s image."
    },
    "noSexualContent": {
      "title": "No sexual content",
      "description": "No explicit photos, messages, or requests. Purity is not optional here."
    },
    "noDominance": {
      "title": "Do not dominate or control",
      "description": "No coercion, manipulation, or pressure. Love does not control."
    },
    "hint": "Tick all three promises before you continue."
  },
  "intent": {
    "eyebrow": "",
    "title": "What are you looking for?",
    "text": "",
    "marriage": {
      "label": "A life partner",
      "description": ""
    },
    "discernment": {
      "label": "Serious discernment",
      "description": ""
    },
    "notCasual": {
      "label": "Nothing casual",
      "description": ""
    },
    "hint": "Pick one."
  },
  "account": {
    "eyebrow": "Account",
    "title": "Create your access",
    "text": "Your handle creates a stable user id. Application, verification, likes, and matches all bind to that id. No email is sent.",
    "recoveryTitle": "Save your recovery code",
    "recoveryText": "Shown once. Without it, a lost passphrase cannot be reset in this closed test.",
    "savedContinue": "I have saved it — continue",
    "handle": "Handle",
    "handlePlaceholder": "you@example.com or a short handle",
    "passphrase": "Passphrase",
    "passphrasePlaceholder": "At least 8 characters",
    "signedInTitle": "Signed in",
    "signedInBody": "{email} · {userId}",
    "trustTitle": "Trust standard",
    "trustBody": "No profile is visible until identity verification is complete and moderation approves you.",
    "continueToVerification": "Continue to verification",
    "hintEmail": "Type an email address that includes @.",
    "hintPassword": "Choose a password of at least 8 characters."
  },
  "verify": {
    "intro": {
      "eyebrow": "Verification",
      "title": "Trust is the gate",
      "text": "Upload a government ID, a confirmation video, and {min}–{max} real photos. Everything enters a review queue before your profile can appear.",
      "whyTitle": "Why we verify",
      "whyBody": "Catfishing and half-truths have no place here. Fake profiles are banned permanently. Media is stored with status pending_review until approved.",
      "start": "Start verification"
    },
    "steps": {
      "id": {
        "title": "Government ID",
        "description": "Passport or national ID — camera or file upload."
      },
      "video": {
        "title": "Confirmation video",
        "description": "A short recording that proves you are present."
      },
      "photos": {
        "title": "Real photos",
        "description": "Seven to ten clear photos of yourself."
      },
      "review": {
        "title": "Integrity review",
        "description": "Uploads stay pending_review until staff confirm."
      }
    },
    "id": {
      "eyebrow": "Step 1 of 4",
      "title": "Government ID",
      "text": "Capture or upload your passport or national ID. Nothing is posted publicly — status stays pending_review until staff confirm.",
      "savedTitle": "ID saved",
      "savedBody": "Next is a short confirmation video of your face, then 7 to 10 real photos of yourself. Continue unlocks when this ID shows saved.",
      "hint": "Take or upload a photo of your government ID, then wait until it says saved."
    },
    "video": {
      "eyebrow": "Step 2 of 4",
      "title": "Confirmation video",
      "text": "Record a short clip or upload one. Face the camera. Speak clearly. This proves you are present — not a scraped gallery.",
      "hint": "Record a short confirmation video, then wait until it says saved."
    },
    "photos": {
      "eyebrow": "Step 3 of 4",
      "title": "Real photos",
      "text": "Add {min}–10 recent photos of yourself. Use the camera or your library. Tap × to remove any shot.",
      "continueToReview": "Continue to review",
      "hint": "Add {min} to 10 clear photos of yourself. Continue unlocks when they are saved."
    },
    "review": {
      "eyebrow": "Step 4 of 4",
      "title": "Integrity review",
      "text": "Media is queued as pending_review{underUser}. Matches and likes will use the same id.",
      "underUser": " under user {userId}",
      "governmentId": "Government ID",
      "confirmationVideo": "Confirmation video",
      "photos": "Photos",
      "missing": "Missing",
      "filesReady": "{count} files ready",
      "submittedTitle": "Submitted for review",
      "submittedText": "Application id equals auth user id so approve → pool and mutual likes stay aligned.",
      "submitContinue": "Submit & continue"
    }
  },
  "setup": {
    "eyebrow": "Account setup",
    "title": "Tell the truth about yourself",
    "text": "These answers shape matching and appear in review. Soft lies waste everyone’s time — including yours.",
    "beginSetup": "Begin setup",
    "pillars": {
      "faith": {
        "name": "Faith",
        "text": "Why you follow Christ."
      },
      "character": {
        "name": "Character",
        "text": "Loyalty, honesty, passion, commitment — rated 1–10."
      },
      "story": {
        "name": "Story",
        "text": "Who you are and what you seek."
      },
      "life": {
        "name": "Life",
        "text": "Hobbies, reading, and vocation."
      }
    },
    "whyChristian": {
      "eyebrow": "Faith",
      "title": "Why are you a Christian?",
      "text": "A short, honest answer. Not a sermon — a reason that is yours.",
      "label": "Your answer",
      "placeholder": "e.g. I met Christ in a season of loss and have followed Him since…",
      "hint": "Write at least {min} characters about why you follow Jesus."
    }
  },
  "scales": {
    "eyebrow": "Character scales",
    "title": "Rate yourself honestly",
    "text": "Loyalty, honesty, passion, commitment — each from 1 to 10. Inflating numbers only mismatches you later. You must set every scale to continue.",
    "loyalty": {
      "label": "Level of loyalty",
      "hint": "Be honest — how faithfully do you stand by those you love?"
    },
    "honesty": {
      "label": "Level of honesty",
      "hint": "How consistently do you tell the full truth?"
    },
    "passion": {
      "label": "How passionate are you?",
      "hint": "Conviction and depth — not performance."
    },
    "commitment": {
      "label": "Level of commitment",
      "hint": "How ready are you to build something that lasts?"
    },
    "hint": "Move every slider so a number shows — none may stay as a dash."
  },
  "about": {
    "eyebrow": "About you",
    "title": "Describe yourself in a few sentences",
    "text": "Who you are when no one is performing. Temperament, rhythm, what matters day to day.",
    "label": "About you",
    "placeholder": "Quiet mornings, serious about family, laugh easily, prefer depth over noise…",
    "hint": "Write at least {min} characters about yourself."
  },
  "looking": {
    "eyebrow": "Partner",
    "title": "What are you looking for?",
    "text": "Main character traits you desire in a potential partner — not a shopping list of looks.",
    "label": "Desired character traits",
    "placeholder": "e.g. Steadfast faith, emotional maturity, kindness under stress…",
    "hint": "Write at least {min} characters about the partner you hope for."
  },
  "loveReady": {
    "eyebrow": "Threshold",
    "title": "Are you ready to meet the love of your life?",
    "text": "UN8 exists so serious singles find a partner — then delete the app. Only “Yes” unlocks continue.",
    "yesTitle": "Yes — I am ready",
    "yesBody": "I am here to meet my person with clarity and courage.",
    "noTitle": "Not yet",
    "noBody": "If you are only browsing, this community is not the right fit.",
    "comeBackTitle": "Come back when ready",
    "comeBackBody": "UN8 is for people prepared to meet — not to collect options. Use Leave below if you want to stop for now. Your answers are saved on this phone.",
    "hintNo": "Only “Yes” continues. If you are not ready, tap Leave for now — your answers stay on this phone.",
    "hintUnset": "Tap Yes if you are ready to meet someone for marriage."
  },
  "lifestyle": {
    "eyebrow": "Lifestyle",
    "title": "How you live day to day",
    "text": "Sports, hobbies, reading, and profession — practical signals for real compatibility.",
    "hobbies": "Current sports or hobbies",
    "hobbiesPlaceholder": "What you actively do — not what you used to do once.",
    "reading": "Do you read?",
    "readingHint": "1 = almost never · 10 = daily, deep reading",
    "profession": "Profession / sector",
    "professionPlaceholder": "e.g. Nursing · Software · Education · Trades",
    "hintHobbies": "Name at least one sport or hobby you actually do.",
    "hintReading": "Slide “Do you read?” so a number from 1 to 10 shows.",
    "hintProfession": "Type the work you do, even a short word."
  },
  "faithDepth": {
    "eyebrow": "Matching · Faith",
    "title": "How central is your faith?",
    "text": "Serving God — how important in your life? Answer honestly. Matching uses this for depth, not performance.",
    "serving": "Serving God — importance",
    "servingHint": "10% … 100%. Slide in steps of 10.",
    "keepsCommandments": "Do you keep the commandments?",
    "grewUpInChurch": "Did you grow up in church?",
    "churchAttendance": "Church attendance",
    "frequent": {
      "label": "Frequent",
      "hint": "Regular gathering with the body of Christ."
    },
    "seldom": {
      "label": "Seldom",
      "hint": "Occasionally, not a weekly rhythm."
    },
    "never": {
      "label": "Never",
      "hint": "Not currently attending."
    },
    "spreadsGospel": "Do you spread the gospel?",
    "hasIdols": "Do you have idols?",
    "hintServing": "Slide how important serving God is in your life.",
    "hintCommandments": "Answer whether you keep the commandments — Yes or No.",
    "hintGrewUp": "Answer whether you grew up in church — Yes or No.",
    "hintAttendance": "Choose how often you attend church.",
    "hintGospel": "Answer whether you share the gospel — Yes or No.",
    "hintIdols": "Answer whether you have idols — Yes or No."
  },
  "character": {
    "eyebrow": "Matching · Character",
    "title": "Who you are at home",
    "text": "Character for courtship — peacemaking, manners, honesty. Inflating answers only mismatches you later.",
    "peacemaker": "Are you a peacemaker?",
    "homebuilder": "Are you a homebuilder?",
    "humorous": "Are you humorous?",
    "caring": "Caring and affectionate?",
    "peacefulHome": "Do you want a peaceful home — free of fighting?",
    "manners": "Good manners?",
    "honestyRating": "Honesty rating on this questionnaire",
    "honestyHint": "1–10 — how honestly are you answering?",
    "hintPeacemaker": "Answer each Yes or No, starting with peacemaker.",
    "hintHomebuilder": "Answer whether you are a homebuilder.",
    "hintHumorous": "Answer whether you are humorous.",
    "hintCaring": "Answer whether you are caring and affectionate.",
    "hintPeaceful": "Answer whether you want a peaceful home.",
    "hintManners": "Answer whether you have good manners.",
    "hintHonesty": "Slide your honesty rating from 1 to 10."
  },
  "history": {
    "eyebrow": "Matching · History",
    "title": "Past and readiness",
    "text": "Substances, childhood, scars, and whether you are ready for a lasting relationship. Truth here protects both of you.",
    "marijuana": "Have you used marijuana?",
    "lsd": "Have you used LSD?",
    "otherDrugs": "Have you used other drugs?",
    "addicted": "Have you been addicted?",
    "childhood": "Stable, loving childhood?",
    "scars": "Any scars / damaged?",
    "lasting": "Ready for a lasting relationship?",
    "hintStart": "Answer every Yes or No on this page, starting at the top.",
    "hintLsd": "Answer the LSD question — Yes or No.",
    "hintOtherDrugs": "Answer whether you have used other drugs.",
    "hintAddicted": "Answer whether you have been addicted.",
    "hintChildhood": "Answer whether your childhood was stable and loving.",
    "hintScars": "Answer whether you carry scars.",
    "hintLasting": "Answer whether you are ready for a lasting relationship."
  },
  "appearance": {
    "eyebrow": "Matching · Appearance",
    "title": "Tattoos",
    "text": "Your tattoos, and whether tattoos on a partner are acceptable to you.",
    "hasTattoos": "Do you have tattoos?",
    "acceptsPartner": "Accept tattoos on a partner?",
    "hintHas": "Say whether you have tattoos — Yes or No.",
    "hintAccepts": "Say whether tattoos on a partner are acceptable to you."
  },
  "home": {
    "eyebrow": "Matching · Home & land",
    "title": "Land, skills, self-sufficiency",
    "text": "Herbs, growing food, fruit forest, prepping, community farming, preserving, survival — and any special skills.",
    "herbKnowledge": "Herb knowledge?",
    "plantOwn": "Do you plant your own fruit and vegetables?",
    "fruitForest": "Interested in a fruit forest?",
    "prepping": "Prepping for calamities?",
    "communityFarming": "Community farming / independent living?",
    "canning": "Canning and preserving?",
    "survival": "Survival skills?",
    "specialSkills": "Special skills (optional)",
    "specialPlaceholder": "Anything else you bring to a household or land…",
    "hintStart": "Answer every Yes or No on land and skills, starting at the top.",
    "hintPlant": "Answer whether you plant your own fruit and vegetables.",
    "hintFruitForest": "Answer whether a fruit forest interests you.",
    "hintPrepping": "Answer whether you prep for calamities.",
    "hintCommunity": "Answer whether community farming interests you.",
    "hintCanning": "Answer whether you can and preserve food.",
    "hintSurvival": "Answer whether you have survival skills."
  },
  "family": {
    "eyebrow": "Matching · Family",
    "title": "Children, faith depth, substances",
    "text": "What you need in a partner on faith intensity, children, and past substance use.",
    "children": "Children",
    "wants": {
      "label": "Wants children",
      "hint": "Building a family is part of the vision."
    },
    "doesNotWant": {
      "label": "Does not want children",
      "hint": "Clear no on children."
    },
    "open": {
      "label": "Open",
      "hint": "Discerning — not locked either way."
    },
    "hasLivingWith": {
      "label": "Has children — living with them",
      "hint": "Children are already part of daily life."
    },
    "requiredFaith": "Minimum faith level you need in a partner",
    "requiredFaithHint": "10% … 100%. Hard gate when both sides have answered.",
    "acceptsSubstances": "Accept past substance use in a partner?",
    "hintChildren": "Choose one card about children.",
    "hintFaith": "Slide the minimum faith level you hope for in a partner.",
    "hintSubstances": "Say whether past substance use in a partner is acceptable."
  },
  "ancestry": {
    "eyebrow": "Matching · Background",
    "title": "Background preferences",
    "text": "Share your background and what you are open to in a partner. This only shapes ranking — it never hides someone from the deck.",
    "yourBackground": "Your background (select all that apply)",
    "openToPartner": "Open to in a partner",
    "codeDesc": "Code: {code}",
    "anyDesc": "Strongest preference for breadth — recommended when unsure.",
    "preferenceOnly": "Preference only — not a gate.",
    "hintOwn": "Tick at least one background that describes you. This only helps ranking — it never hides anyone.",
    "hintAccepted": "Tick what you are open to in a partner, or “Open — no preference”."
  },
  "interests": {
    "eyebrow": "Matching · Interests",
    "title": "What you enjoy",
    "text": "Pick at least one. Overlap helps ranking; silence is never punished.",
    "hint": "Tick at least one interest."
  },
  "reflection": {
    "eyebrow": "Matching · Reflection",
    "title": "In your own words",
    "text": "These four answers are shown in full and never scored. Write what is true.",
    "describeYourself": "Describe yourself",
    "lifePurpose": "Life purpose",
    "fifteenYear": "You and the love of your life in 15 years",
    "weaknesses": "Weaknesses",
    "hintDescribe": "Describe yourself in at least {min} characters.",
    "hintPurpose": "Write your life purpose in at least {min} characters.",
    "hintVision": "Write the 15-year vision in at least {min} characters.",
    "hintWeaknesses": "Name a weakness in at least {min} characters."
  },
  "profile": {
    "eyebrow": "Profile",
    "title": "A few essentials",
    "text": "Keep it simple. Sex is binary here — male or female — for clear matching.",
    "firstName": "First name",
    "firstNamePlaceholder": "As you wish to be known",
    "age": "Age",
    "agePlaceholder": "18+",
    "city": "City",
    "cityPlaceholder": "Where you are based",
    "sex": "Sex",
    "maleBody": "I am a man.",
    "femaleBody": "I am a woman.",
    "hintName": "Type your first name (at least two letters).",
    "hintAge": "Age must be 18 or older.",
    "hintCity": "Type the city where you live.",
    "hintGender": "Choose Male or Female so matching can work."
  },
  "ready": {
    "title": "You may enter.",
    "textNamed": "{name}, your verification and setup are recorded. Media is pending_review. Welcome to UN8 — find your person, then delete the app.",
    "text": "Your verification and setup are recorded. Media is pending_review. Welcome to UN8 — find your person, then delete the app.",
    "summaryAria": "Setup summary",
    "christianRules": "Christian · rules affirmed",
    "mediaLine": "ID · video · {photoCount} photos · queue {pending}",
    "scalesLine": "Scales L{loyalty}/H{honesty}/P{passion}/C{commitment}",
    "genderProfession": "{gender} · {profession}",
    "sexUnset": "Sex —",
    "professionFallback": "profession",
    "userLine": "User {userId}",
    "enterMatching": "Enter matching",
    "needGender": "Go back to the profile step and choose Male or Female, then try again."
  },
  "match": {
    "brandTag": "Matching",
    "navOnboarding": "Onboarding",
    "navReview": "Review",
    "navMatching": "Matching",
    "logOut": "Log out",
    "enterTitle": "Enter matching",
    "enterText": "Log in with the same email from onboarding. Application, pool, likes, and matches all use your stable user id.",
    "email": "Email",
    "emailPlaceholder": "you@example.com",
    "password": "Password",
    "passwordPlaceholder": "Your password",
    "logIn": "Log in",
    "guestOr": "Or try a guest session (stable id per browser · demo only)",
    "guestMan": "Guest as man",
    "guestWoman": "Guest as woman",
    "goOnboarding": "Go to onboarding →",
    "guestSession": "Guest session · demo pool",
    "man": "man",
    "woman": "woman",
    "tabToday": "Today",
    "tabMatches": "Matches ({count})",
    "yourMatches": "Your matches",
    "matchesSub": "Persistent mutual interest · {count} outbound {likesWord}",
    "like": "like",
    "likes": "likes",
    "emptyMatches": "No mutual interest yet. Keep discerning today’s suggestions.",
    "valuesScore": "Values {score}",
    "chatOpen": " · Chat open",
    "tapToChat": " · Tap to chat",
    "personLine": "{name}, {age}",
    "cityValues": "{city} · Values {score}",
    "noProfileYet": "No profile yet",
    "noProfileText": "Finish onboarding, or tap Onboarding at the top, then Begin. Guest matching is on the enter screen if you only want to look.",
    "matchingPaused": "Matching paused",
    "moderationDemoNote": "Showing demo people so you can try matching while you wait.",
    "noOneYet": "No one to show yet",
    "todaysSetDone": "That’s today’s set",
    "weeklyTitle": "Your 4 for this week",
    "weeklyTitleCount": "Your {count} for this week",
    "weeklyCountdown": "Next selection in {days} days",
    "weeklyCountdownOne": "Next selection in 1 day",
    "weeklyCountdownSoon": "Next selection soon",
    "shortWeekCopy": "This week there are {count}. We never suggest someone who is not a fit.",
    "shortWeekTwo": "This week there are two. We never suggest someone who is not a fit.",
    "weekDone": "That’s this week’s selection",
    "weekDoneText": "You have discerned everyone we could honestly suggest. Come back when the next selection opens.",
    "emptyNeverHad": "There is nobody in this week’s list yet. We are still filling the pool — open Selection again in a moment, or come back when more members are approved.",
    "emptyDone": "You have gone through today’s suggestions. Come back tomorrow, or reset the deck to look again.",
    "likesMayNotStick": " Likes may not stick.",
    "poolMeta": "Pool: {pool} · Matches: {matches} · Liked: {liked}",
    "demoPool": "demo",
    "livePool": "{source} ({count})",
    "resetDeck": "Reset deck",
    "backOnboarding": "Back to onboarding",
    "feedEyebrowDemo": "Today’s suggestions · Demo pool",
    "feedEyebrowLive": "Today’s suggestions · Pool ({source}, {count})",
    "feedTitle": "Discern with care",
    "left": "{count} left",
    "pass": "Pass",
    "interested": "Interested",
    "swipeHint": "Swipe or use the buttons. A match opens only when interest is mutual and persisted.",
    "celebrationEyebrow": "Mutual interest",
    "celebrationTitle": "You matched",
    "celebrationText": "{self} and {other} both showed interest. Values alignment: {score}.",
    "celebrationNote": "Chat is unlocked for this match. Keep it respectful — covenant over convenience.",
    "openChat": "Open chat",
    "keepDiscerning": "Keep discerning",
    "cardSeeking": "Seeking",
    "cardHobbies": "Hobbies",
    "affinity": "Affinity",
    "valuesScoreLabel": "Values score",
    "scoreStrong": "Strong alignment",
    "scoreSolid": "Solid alignment",
    "scoreModerate": "Moderate alignment",
    "scoreDifferent": "Different rhythms",
    "characterAxisFoot": "Character axis includes the four pillars",
    "youThem": "You {self} · Them {other}",
    "stampInterest": "Interest",
    "stampPass": "Pass",
    "explainLegacyClose": "Your values scores sit close together ({score} of 100).",
    "explainLegacyFuller": "A fuller “why” appears after both of you finish the matching questions.",
    "explainFaith": "Your faith intensity is close — you take following Jesus with similar seriousness.",
    "explainCharacter": "How you treat people at home lines up — peace, manners, and care.",
    "explainPurpose": "You rated your own honesty similarly, which is a sign of shared seriousness.",
    "explainHome": "You share an interest in land, growing food, or a self-sufficient home.",
    "explainAncestry": "You both prefer similar family backgrounds. That is a preference, not a filter — nobody is hidden for it.",
    "explainTemperament": "Your interests and temperament overlap.",
    "explainFallback": "There is a possible match on the answers you both filled in.",
    "explainOverall": "Overall affinity {score} of 100.",
    "affinityAxes": {
      "faith": "Faith intensity",
      "character": "Character & conduct",
      "purpose": "Life purpose alignment",
      "home": "Home & self-sufficiency",
      "ancestry": "Cultural & background affinity",
      "temperament": "Temperament fit"
    },
    "scaleAxes": {
      "loyalty": "Loyalty",
      "honesty": "Honesty",
      "passion": "Passion",
      "commitment": "Commitment"
    }
  },
  "chat": {
    "brandTag": "Chat",
    "unavailableTitle": "Chat unavailable",
    "unavailableText": "This match is missing or does not belong to your session.",
    "backToMatches": "Back to matches",
    "backMatches": "← Matches",
    "valuesSubscriber": "Values {score} · Subscriber",
    "valuesTrial": "Values {score} · Trial",
    "valuesKept": "Values {score} · Match kept",
    "empty": "Say hello with care. On the shared backend, messages sync to both phones after a mutual match.",
    "placeholder": "Message {name}…",
    "ariaMessage": "Message",
    "send": "Send"
  },
  "billing": {
    "paywallCopy": "After your free trial, keep everyone you have already matched with and keep chatting. To see new people, subscribe.",
    "signInToMatch": "Sign in to use matching.",
    "signInFirst": "Sign in first.",
    "subscriberUntil": "Subscriber · until {date}",
    "renewal": "renewal",
    "freeTrial": "Free trial · {days} days (ends {date})",
    "soon": "soon",
    "trialEnded": "Trial ended · matches & chat stay open",
    "subscribe": "Subscribe · ${price}/mo",
    "subscribeEarly": "Subscribe early · ${price}/mo",
    "activeNote": "Subscription active — you can see new people again.",
    "playOnly": "Subscription is Google Play Billing only (app install). There is no web checkout here.",
    "playOnlyShort": "Billing via Google Play only — no web payment."
  },
  "auth": {
    "recoveryTitle": "Save your recovery code",
    "recoveryText": "Write this down now. It is shown once. If you lose your passphrase, this code is the only way to reset it in the closed test.",
    "savedContinue": "I have saved it — continue",
    "welcomeBack": "Welcome back",
    "createAccount": "Create your account",
    "intro": "Handle and passphrase. No email or SMS is sent. Your id stays stable across onboarding, review, and matching.",
    "tabLogin": "Log in",
    "tabRegister": "Register",
    "handle": "Handle",
    "handlePlaceholder": "you@example.com or a short handle",
    "passphrase": "Passphrase",
    "passphrasePlaceholder": "At least 8 characters",
    "submitLogin": "Log in",
    "submitRegister": "Create account",
    "backWelcome": "Back to welcome"
  },
  "options": {
    "origin": {
      "african": "African",
      "european": "European",
      "asian": "Asian",
      "latino": "Latino / Hispanic",
      "middleEastern": "Middle Eastern",
      "indigenous": "Indigenous",
      "mixed": "Mixed",
      "other": "Other",
      "dutch": "Dutch",
      "german": "German",
      "any": "Open — no preference"
    },
    "interest": {
      "prayer": "Prayer",
      "worship": "Worship",
      "reading": "Reading",
      "hiking": "Hiking",
      "music": "Music",
      "cooking": "Cooking",
      "farming": "Farming / gardening",
      "sports": "Sports",
      "missions": "Missions",
      "family": "Family life",
      "crafts": "Crafts",
      "outdoors": "Outdoors"
    }
  },
  "capture": {
    "yesNoDefaults": {
      "yes": "Yes",
      "no": "No"
    },
    "id": {
      "titleEmpty": "Government ID",
      "titleReady": "ID ready",
      "hintEmpty": "Passport or national ID. Take a live photo, or choose an image/PDF. All four corners visible.",
      "hintReady": "{fileName} · {bytes}{saved}",
      "savedSuffix": " · saved",
      "previewAlt": "Government ID preview",
      "pdfAria": "PDF document selected",
      "takePhoto": "Take photo",
      "retake": "Retake",
      "chooseFile": "Choose file",
      "replaceFile": "Replace file",
      "remove": "Remove",
      "uploading": "Uploading…",
      "cameraTitle": "Photograph your ID",
      "signIn": "Sign in before uploading ID.",
      "uploadFailed": "Upload failed. Try again.",
      "badFile": "Could not use this file."
    },
    "video": {
      "titleEmpty": "Confirmation video",
      "titleLive": "Camera live",
      "titleReady": "Video ready",
      "hintEmpty": "Say your first name and that you join UN8 honestly. 5–15 seconds.",
      "hintReady": "{fileName} · {bytes}{saved}",
      "rec": "REC {seconds}s",
      "record": "Record",
      "cameraUpload": "Camera upload",
      "chooseFile": "Choose file",
      "startRecording": "Start recording",
      "cancel": "Cancel",
      "stopSave": "Stop & save",
      "recordAgain": "Record again",
      "replaceFile": "Replace file",
      "remove": "Remove",
      "unsupported": "Live recording is unavailable here. Use camera upload or choose a file.",
      "permissionDenied": "Camera permission denied. You can still upload a short video file.",
      "signIn": "Sign in before uploading video.",
      "uploadFailed": "Upload failed. Try again.",
      "saveFailed": "Could not save recording.",
      "badVideo": "Could not use this video."
    },
    "photos": {
      "count": "{count} / {max} photos",
      "minimumMet": "Minimum met",
      "moreRequired": "{n} more required",
      "listAria": "Verification photos",
      "photoAlt": "Photo {n}",
      "removeAria": "Remove photo {n}",
      "camera": "Camera",
      "takePhoto": "Take photo",
      "chooseFiles": "Choose files",
      "uploading": "Uploading…",
      "hint": "Take photo opens the live camera. Choose files is only for gallery picks. Clear face shots — no filters that hide identity. Max {max}.",
      "cameraTitle": "Take a photo of yourself",
      "signIn": "Sign in before uploading photos.",
      "someFailed": "Some photos failed to upload. Retry the failed ones.",
      "addFailed": "Could not add photos."
    },
    "liveStill": {
      "titleDefault": "Camera",
      "close": "Close",
      "capture": "Capture",
      "cancel": "Cancel",
      "hint": "Hold steady. The live camera stays open until you capture.",
      "unavailable": "Camera is not available in this browser. Use Choose file instead.",
      "permissionDenied": "Camera permission denied or unavailable. Use Choose file instead.",
      "frameFailed": "Could not capture this frame.",
      "saveFailed": "Could not save the photo."
    },
    "uploadStatus": {
      "uploading": "uploading…",
      "failed": "upload failed",
      "savedLocally": "saved locally",
      "uploaded": "uploaded",
      "stored": "stored",
      "awaitingUpload": "Awaiting upload",
      "localFallbackNote": "{error} File is saved on this device; retry when the sign endpoint is up."
    }
  },
  "language": {
    "label": "Language",
    "choose": "Choose language"
  },
  "shell": {
    "back": "Back",
    "goBackAria": "Go back"
  }
} as Messages;
